export default __webpack_public_path__ + "static/media/nav-logo.097abf3e.svg";